// External Dependencies:
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import i18n from 'i18n-calypso'

// Internal Dependencies:
import { doRequest } from 'utilities/request'

export function addScript( value ) {
	return {
		type: 'ADD_SCRIPT',
		value: value
	}
}

export function setLocale( locale ) {
	return function( dispatch, getState ) {
		// Short circuit for existing data:
		if ( locale == getState().site.locale ) {
			return
		}

		dispatch( setLocaleString( locale ) )

		if ( 'en' === locale ) {
			// Use default english text:
			i18n.setLocale( false )

			return
		}

		return doRequest( `${siteData.languages_url}${locale}.json?v=${siteData.version}` )
			.then( json => {
				// Load the locale.
				i18n.setLocale( json )
			})
			.catch( error => {

			})
	}
}

export function setLocaleString( locale ) {
	return {
		type: 'SET_LOCALE',
		value: locale
	}
}

export function openMenu() {
	return {
		type: 'OPEN_MENU'
	}
}

export function closeMenu() {
	return {
		type: 'CLOSE_MENU'
	}
}

export function login() {
	return {
		type: 'LOGIN'
	}
}

export function loginDisabled( value ) {
	return {
		type: 'LOGIN_DISABLED',
		value: value
	}
}

export function loginProcessing() {
	return {
		type: 'LOGIN_PROCESSING'
	}
}

export function loginProcessed() {
	return {
		type: 'LOGIN_PROCESSED'
	}
}

export function loginError() {
	return {
		type: 'LOGIN_ERROR'
	}
}

export function loginSuccess() {
	return {
		type: 'LOGIN_SUCCESS'
	}
}

export function loginMessage( message ) {
	return {
		type: 'LOGIN_MESSAGE',
		message: message
	}
}

export function logout() {
	return {
		type: 'LOGOUT'
	}
}

export function submitLogin( username, password ) {
	return function( dispatch ) {
		dispatch( loginDisabled( true ) )
		dispatch( loginProcessing() )

		return doRequest( siteData.api_base_url + '/login/?username=' + username + '&password=' + password )
			.then( json => {
				dispatch( loginProcessed() )

				// add a delay for UX
				setTimeout( () => {
					dispatch( loginSuccess() )

					setTimeout( () => {
						dispatch( loginDisabled( false ) )
						dispatch( login() )
					}, 1000 )
				}, 1000 )
			})
			.catch( function( response ) {
				dispatch( loginProcessed() )

				// add a delay for UX
				setTimeout( () => {
					dispatch( loginError() )

					setTimeout( () => {
						dispatch( loginDisabled( false ) )
					}, 1000 )
				}, 1000 )
			})
	}
}

export function requestMenuData() {
	return {
		type: 'REQUEST_MENU_DATA'
	}
}

export function getMenuData( username, password ) {
	return function( dispatch, getState ) {
		const { isLoadingMenu } = getState().site

		// Don't load the same thing simultaneously:
		if ( isLoadingMenu ) {
			return
		}

		dispatch( requestMenuData() )

		const { locale } = getState().site

		return doRequest( siteData.api_base_url + 'menu/?locale=' + locale + '&v=' + siteData.version )
			.then( json => {
				dispatch( receiveMenuData( json ) )
			})
			.catch( error => {

			})
	}
}

export function receiveMenuData( data ) {
	return {
		type: 'RECEIVE_MENU_DATA',
		value: data
	}
}



// WEBPACK FOOTER //
// ./redux/actions/site.jsx